import React from 'react';
import styled from 'styled-components';

const ModifyItem = ({ title, description }) => {
  return (
    <ModifyItemContainer className='d-flex flex-row align-items-center border-gray-200'>
      <ModifyItemTitleWrapper>
        <ModifyItemTitle className='text-gray-600'>{title}</ModifyItemTitle>
      </ModifyItemTitleWrapper>
      <ModifyItemTextWrapper className='pl-2'>
        <ModifyItemText className='text-gray-800 mb-0'>
          {description}
        </ModifyItemText>
      </ModifyItemTextWrapper>
    </ModifyItemContainer>
  );
};

const ModifyItemContainer = styled.section`
  height: 53px;
  border-bottom: 1px solid ${(props) => props.theme.$gray200};
`;
const ModifyItemTitleWrapper = styled.article`
  width: 70px;
`;
const ModifyItemTitle = styled.h5``;
const ModifyItemTextWrapper = styled.article``;
const ModifyItemText = styled.p``;

export default ModifyItem;
